import { Dispatch, SetStateAction } from 'react';
import { useMutation, useQueryClient } from 'react-query';

import { errorMessage } from '@features/applications';
import axiosInstance from '@server/axiosInstance';
import { updatePayrollPartnerRoute } from '../api/constants';
import { onboardPackagesList, payrollpartnersList } from '../constants';

type useUpdatePayrollPartnerProps = {
    setErrorText: Dispatch<SetStateAction<string>>;
};

export const useUpdatePayrollPartner = ({
    setErrorText,
}: useUpdatePayrollPartnerProps) => {
    const client = useQueryClient();
    const { mutate: updatePayrollPartner, isLoading: isUpdatingPayrollPartner } =
        useMutation({
            mutationFn: (variables: {
                email?: string;
                name?: string;
                company_id?: number;
                company_name?: string;
                partner_id?: number;
            }) =>
                axiosInstance
                    .post(updatePayrollPartnerRoute, variables) 
                    .then((res) => res.data),
            onSuccess: (data) => {
                if (data.status === 200) {
                    client.invalidateQueries([payrollpartnersList]);
                    client.invalidateQueries([onboardPackagesList]);
                    setErrorText('');
                } else {
                    setErrorText(data?.message || errorMessage);
                }
            },
            onError: (error: { message?: string }) => {
                setErrorText(error?.message || errorMessage);
            },
        });

    return {
        updatePayrollPartner,
        isUpdatingPayrollPartner,
    };
};
